/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyRightAnswersDto
 */
export interface PropertyRightAnswersDto {
    /**
     * 
     * @type {boolean}
     * @memberof PropertyRightAnswersDto
     */
    hasTenancyRights: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyRightAnswersDto
     */
    tenantOrOwnerOfHomeAddress: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyRightAnswersDto
     */
    hasCompanyShares: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyRightAnswersDto
     */
    hasCooperativeMemberships: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyRightAnswersDto
     */
    hasOtherPropertyRights: boolean | null;
}

/**
 * Check if a given object implements the PropertyRightAnswersDto interface.
 */
export function instanceOfPropertyRightAnswersDto(value: object): value is PropertyRightAnswersDto {
    if (!('hasTenancyRights' in value) || value['hasTenancyRights'] === undefined) return false;
    if (!('tenantOrOwnerOfHomeAddress' in value) || value['tenantOrOwnerOfHomeAddress'] === undefined) return false;
    if (!('hasCompanyShares' in value) || value['hasCompanyShares'] === undefined) return false;
    if (!('hasCooperativeMemberships' in value) || value['hasCooperativeMemberships'] === undefined) return false;
    if (!('hasOtherPropertyRights' in value) || value['hasOtherPropertyRights'] === undefined) return false;
    return true;
}

export function PropertyRightAnswersDtoFromJSON(json: any): PropertyRightAnswersDto {
    return PropertyRightAnswersDtoFromJSONTyped(json, false);
}

export function PropertyRightAnswersDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyRightAnswersDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hasTenancyRights': json['hasTenancyRights'],
        'tenantOrOwnerOfHomeAddress': json['tenantOrOwnerOfHomeAddress'],
        'hasCompanyShares': json['hasCompanyShares'],
        'hasCooperativeMemberships': json['hasCooperativeMemberships'],
        'hasOtherPropertyRights': json['hasOtherPropertyRights'],
    };
}

export function PropertyRightAnswersDtoToJSON(json: any): PropertyRightAnswersDto {
    return PropertyRightAnswersDtoToJSONTyped(json, false);
}

export function PropertyRightAnswersDtoToJSONTyped(value?: PropertyRightAnswersDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasTenancyRights': value['hasTenancyRights'],
        'tenantOrOwnerOfHomeAddress': value['tenantOrOwnerOfHomeAddress'],
        'hasCompanyShares': value['hasCompanyShares'],
        'hasCooperativeMemberships': value['hasCooperativeMemberships'],
        'hasOtherPropertyRights': value['hasOtherPropertyRights'],
    };
}

